// Hold-failure messaging shared by the booking panels. Moved from
// ServicePanel.tsx with zero behaviour change.

import { useState } from "react";
import { describeReason } from "@vertu/shared";

// The oversize-party 'enquiry' policy is a ROUTE, not just a rejection —
// when a hold fails with oversize_party_enquiry and the widget has an
// Enquire tab, the error banner carries a CTA that jumps there pre-scoped
// to this service. Every hold failure funnels through reportHoldFailure so
// the flag can never go stale against the message.
export function useHoldFailure(onEnquire: (() => void) | undefined) {
  const [error, setError] = useState<string | null>(null);
  const [errorEnquiryCta, setErrorEnquiryCta] = useState(false);
  // `message` lets the panel replace the shared copy where it knows more
  // (a menu refusal with no menu chooser on screen).
  function reportHoldFailure(hold: { reason: string }, message?: string | null) {
    setError(message ?? describeReason(hold));
    setErrorEnquiryCta(hold.reason === "oversize_party_enquiry" && onEnquire != null);
  }
  return { error, setError, errorEnquiryCta, reportHoldFailure };
}

// The caller renders this as `{error && <HoldErrorBanner error={error} />}`.
// Keep that guard at the call site, not in here: React commits a parent's
// deletions before it walks the parent's children, so a guard inside this
// component would remove the banner after the sibling cards update instead of
// before them.
export function HoldErrorBanner({
  error,
  errorEnquiryCta,
  onEnquire,
}: {
  error: string;
  errorEnquiryCta: boolean;
  onEnquire?: () => void;
}) {
  return (
    <div className="vt-capacity-error">
      <span>{error}</span>
      {errorEnquiryCta && onEnquire && (
        <button
          type="button"
          className="vt-cta-inline vt-error-enquire-cta"
          onClick={onEnquire}
        >
          Enquire about your group →
        </button>
      )}
    </div>
  );
}
